
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PrepagaComponent } from './prepaga.component';
import { GraciasComponent } from './pages/gracias/gracias.component';






const routes: Routes = [
  {
    path: '',
    component: PrepagaComponent,
  },
  {
    path: 'gracias',
    component: GraciasComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrepagaRoutingModule {

}
